export default "__VITE_ASSET__Cv5mTr7m__"